module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.51-202.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.0-rc.51.md
// module id = 645
// module chunks = 363